const accuracyAccountsOverrides = {
  palette: {
    mode: 'light',
    error: {
      main: '#EE242C',
    },
    background: {
      default: '#fff',
      paper: '#fff',
    },
    green: {
      color: '#1DCD9A',
    },
    lightblue: {
      color: '#E8F7FE',
    },
    yellow: {
      color: '#FF9F00',
    },
    red: {
      color: '#EE242C',
    },
    grey: {
      color: 'rgba(0,0,0,0.75)',
    },
    cardBackground: {
      color: '#FFFFFF',
    },
  },
}

export default accuracyAccountsOverrides
